import React from 'react'
import { useEffect, useState } from 'react'
import $ from 'jquery'
import getDomainName from 'helpers/getDomainName'

const FacilityOverview = () => {
  const [embedUrl, setEmbedUrl] = useState()
  const siteId = sessionStorage.getItem('siteId')
  const selectedSiteId = localStorage.getItem('selectedSiteId')
  const [parameter, setParameter] = useState({
    session_id: localStorage.getItem('userLoginSessionId'),
    site_id: selectedSiteId != null && selectedSiteId != undefined ? selectedSiteId : siteId !== null ? siteId : localStorage.getItem('siteId'),
    access_token: localStorage.getItem('accessToken'),
    domain: getDomainName(),
  })

  const createQueryString = params => {
    return Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&')
  }

  useEffect(() => {
    $('#pageLoading').show()
    ;(async () => {
      try {
        const addQueryParam = `https://egalvanic.retool.com/embedded/public/ebd155fd-f77e-4780-ae96-a057cb608434?${createQueryString(parameter)}`
        setEmbedUrl(addQueryParam)
        $('#pageLoading').hide()
      } catch (error) {
        $('#pageLoading').hide()
        console.log(error)
      }
    })()
  }, [])

  return <iframe src={embedUrl} title='description' style={{ height: 'calc(100vh - 70px)', width: '100%' }}></iframe>
}

export default FacilityOverview
